import { FetchParams, Middleware, RequestContext } from '@/api/generated'
import { loggerFor } from '@/shared/utils/logger'

export class LoggingMiddleware implements Middleware {
  private logger = loggerFor('Logging middleware')

  public async pre(context: RequestContext): Promise<FetchParams | void> {
    this.logger.debug(context.url, context.init)
  }
}
